import { Currency } from './Shared/Currency'
import { InvoiceInfo } from './Shared/InvoiceInfo.types'

export enum BonusHistoryTypes {
  Ref = 'Ref',
  Invoice = 'Invoice',
  Bonus = 'Bonus',
  Full = 'Full',
}

export enum ReferralInvoiceDirection {
  FillIn = 'fillIn',
  FillOut = 'fillOut'
}

export type BonusHistoryRequest = {
  type: BonusHistoryTypes
  limit: number
  offset: number
}

export type BonusHistoryRequestType<T> = T extends BonusHistoryTypes.Full
                                          ? { items: FullBonusHistory }
                                          : { items: RefBonusHistory }

export type FullBonusHistory = Array<BonusInfoInvoice>
export type RefBonusHistory = Array<RefBonusHistoryItem>

export type BonusInfoInvoice = Omit<InvoiceInfo, 'positions'> & {
    bonus?: Array<InvoiceBonusItem>
    ref?: Array<Omit<RefBonusHistoryItem, 'referral' | 'invoice'>>
}

export type InvoiceBonusItem = {
    index: number,
    sum: number,
    reward: number,
    currency: Currency
}

export type RefBonusHistoryItem = {
    index: number,
    direction: ReferralInvoiceDirection,
    sum: number
    reward: number
    currency: Currency
    referral: ReferralInfo
    invoice: BonusInfoInvoice
}

export type ReferralInfo = {
  name: string
  avatar: string
  languageCode: string
}
